import Icon from 'components/shared/Icon/Icon';

const ClearIcon = ({ isClearable, onClick, iconColor = 'neutral', isValue }) => {
  if (!isClearable) return null;

  return (
    <Icon
      icon={isValue ? 'close-linear' : 'clock-mono'}
      size={isValue ? 16 : 20}
      className={!isValue && '!cursor-default'}
      color={iconColor}
      onClick={onClick}
    />
  );
};

export default ClearIcon;
